import React, { useEffect, useRef, useState } from "react";
import Button from "../Inputs/Button";

function Steps({ goNext, loading, steps = [], onChange = () => {} }) {
	const [ActiveStep, setActiveStep] = useState(1);
	const [ShouldAutoScroll, setShouldAutoScroll] = useState(false);
	const StepRefs = useRef([]);

	const nextStep = (step) => {
		//Go to next step if onChange handler returns true
		if (onChange(step)) {
			setShouldAutoScroll(true);
			setActiveStep(step);
		}
	};

	useEffect(() => {
		if (goNext) {
			goNext.current = () => {
				setShouldAutoScroll(true);
				setActiveStep((prev) => prev + 1);
			};
		}
	}, [goNext, ActiveStep]);

	useEffect(() => {
		// Keep active step aligned in viewport after step transitions.
		if (!ShouldAutoScroll) return;
		const currentStep = StepRefs.current[ActiveStep - 1];
		if (currentStep) {
			currentStep.scrollIntoView({ behavior: "smooth", block: "start" });
		}
		setShouldAutoScroll(false);
	}, [ActiveStep, ShouldAutoScroll]);

	return (
		<div className="overflow-visible border rounded-md">
			{steps.map((step, index) => {
				const active = index + 1 === ActiveStep;
				return (
					<div
						key={index}
						ref={(el) => {
							StepRefs.current[index] = el;
						}}
						className={`p-2 sm:p-4 ${active ? "" : "bg-light"} border-b`}
					>
						<div className="align-center">
							<div className={`${active ? "bg-primary" : "bg-dark"} text-white text-xs font-bold w-6 h-6 rounded-full flex-center mr-3 sm:mr-4`}>{index + 1}</div>
							<div>
								<h3>{step.heading}</h3>
								<div className="text-xs text-secondary">{step.description}</div>
							</div>
						</div>
						{active && (
							<div className="pt-3 sm:pt-4">
								<div className="mt-3 sm:mt-4">{step.content}</div>
								<div className="flex flex-col-reverse gap-2 mt-4 sm:mt-6 sm:flex-row">
									{ActiveStep < steps.length && (
										<Button loading={loading} onClick={() => nextStep(ActiveStep + 1)} className="w-full sm:w-auto btn-sm" variant="primary">
											Continue
										</Button>
									)}
									{ActiveStep > 1 && (
										<Button
											onClick={() => {
												setShouldAutoScroll(true);
												setActiveStep((prev) => prev - 1);
											}}
											className="w-full sm:w-auto btn-sm"
											variant="outlined"
										>
											Go Back
										</Button>
									)}
								</div>
							</div>
						)}
					</div>
				);
			})}
		</div>
	);
}

export default Steps;
